/*
 * Copyright (c) 2023
 *
 * The source code and all documents related to the source code ("Material") are owned by
 * Frictionless Systems, LLC.
 *
 * The Material contains trade secrets, proprietary information, and confidential information.
 * No part of the Material may be used, copied, reproduced, modified, published, distributed, or
 * disclosed in any way without Frictionless Systems, LLC’s express prior written permission.
 *
 * The Material may be protected under patent, trademark, copyright, or trade secret laws.  No
 * license is granted to you by disclosure or delivery of the Materials.  Any license must be
 * express and approved by Frictionless Systems, LLC in writing.
 *
 * “Frictionless Systems” and “Impulse” are registered trademarks of Frictionless Systems, LLC.
 */

package systems.frictionless.impulse.markdown.model

/**
 * @param text Displayed to the user.
 * @param type Indicates how the [text] is displayed.
 */
data class Token(val text: String, val type: Type) {
    sealed class Type {
        object Plain : Type()

        object Bold : Type()

        object Italic : Type()

        // Implementation note: In the future, a stronger type for Url would be preferred but there's no multiplatform version yet
        data class Link(val url: String) : Type() {
            init {
                require(url.isNotEmpty())
            }
        }
    }
}
